import { createContext } from "react";
const AuthApi = createContext();
export default AuthApi;